import * as React from "react";

import { Root, UnitLoaderBefore } from "./UnitLoader.styles";

export function UnitLoader(): JSX.Element {
    const height = Math.min(document.documentElement?.offsetHeight ?? Infinity, 400);

    return (
        <Root style={{ height: height }}>
            <UnitLoaderBefore />
            Страница загружается...
        </Root>
    );
}
